import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';
import Basepaths from '@mlb/react-patterns/components/Basepaths/basepaths';
import { InningWrapper, SituationWrapper, CountWrapper } from '../../AtBat/summary/Summary.style';

const Situation = ({
    inning,
    halfInning = '',
    offense = {},
    count = {}
}) => {
    const inningHalfText = useTranslator(`game_status_${halfInning.toLowerCase()}`, halfInning === 'Top' ? 'Top' : 'Bot');
    const showInning = inning && halfInning;
    const {
        balls,
        strikes,
        outs
    } = count;
    let outsText = '';

    const translationMap = {
        0: useTranslator('game_noouts', '0 Outs'),
        1: useTranslator('game_oneout', '1 Out'),
        2: useTranslator('game_twoouts', '2 Outs'),
        3: useTranslator('game_threeouts', '3 Outs')
    };

    switch (outs) {
    case 3:
        outsText = translationMap[3];
        break;
    case 2:
        outsText = translationMap[2];
        break;
    case 1:
        outsText = translationMap[1];
        break;
    default:
        outsText = translationMap[0];
    }

    return (
        <SituationWrapper>
            {showInning && <InningWrapper>{inningHalfText} {inning}</InningWrapper>}
            <Basepaths {...offense} width='22' rounded={false} filledColor={'var(--gameday-basepath-color)'} strokeColor={'var(--gameday-basepath-color)'} emptyColor='transparent' />
            <CountWrapper>{balls} - {strikes}, {outsText}</CountWrapper>
        </SituationWrapper>

    );
};

Situation.propTypes = {
    inning: PropTypes.number,
    halfInning: PropTypes.string,
    offense: PropTypes.object,
    count: PropTypes.object
};

export default Situation;
